import { render, staticRenderFns } from "./PrintItem.vue?vue&type=template&id=07bc2966&scoped=true&"
import script from "./PrintItem.vue?vue&type=script&lang=js&"
export * from "./PrintItem.vue?vue&type=script&lang=js&"
import style0 from "./PrintItem.vue?vue&type=style&index=0&id=07bc2966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc2966",
  null
  
)

export default component.exports